import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5516_24344)">
      <path
        d="M12.0936 0C8.73327 0 0.457275 8.27578 0.457275 11.6363C0.457275 14.9968 8.73327 23.2727 12.0936 23.2727C15.4539 23.2727 23.73 14.9967 23.73 11.6363C23.73 8.27593 15.454 0 12.0936 0ZM10.2803 18.2903C8.86323 17.9042 5.0535 11.24 5.43969 9.82298C5.82589 8.40589 12.49 4.59621 13.9069 4.9824C15.324 5.36853 19.1338 12.0327 18.7476 13.4497C18.3614 14.8668 11.6973 18.6765 10.2803 18.2903Z"
        fill="#11181C"
      />
    </g>
    <defs>
      <clipPath id="clip0_5516_24344">
        <rect width="24" height="23.2727" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
